module.exports = __webpack_public_path__ + "static/media/pla_process_1.42c3979a.png";